import { useLocation, useOutlet } from 'react-router-dom';
import { AnimatedContent } from './AnimatedContent';

export const AnimatedOutlet = () => {
  const location = useLocation();
  const outlet = useOutlet();

  return <AnimatedContent contentKey={location.pathname}>{outlet}</AnimatedContent>;
};
